const QUOTES = [
  {
    quote:
      "Cinematic allure and ethereal vocals… a thought-provoking journey with dreamlike sensibilities… feels like an artistic rebirth.",
    source: "K.I.M.U.",
    href: "https://karlismyunkle.com/2026/08/28/a-wider-horizon-explores-communication-emotional-isolation-and-relationship-breakdown-on-cinematic-debut-single-silent-eulogy/",
  },
  {
    quote:
      "By the end it feels less like a song and more like a headspace… slightly unresolved, strangely comforting.",
    source: "Music Evolution",
    href: "https://music-evolution.com/a-wider-horizon-silent-eulogy-new-music/",
  },
  {
    quote:
      "Silent Eulogy is a beautiful combination of gentle and hazy sounds with heavy covibrations.",
    source: "Mangowave Magazine",
    href: "https://mangowave-magazine.com/news/a-wider-horizon-silent-eulogy/",
  },
  {
    quote:
      "The track carries an impressive sense of scale… the guitar work is sublime, building towards a cinematic climax. We are in awe.",
    source: "K.I.M.U.",
    href: "https://karlismyunkle.com/2026/08/28/a-wider-horizon-explores-communication-emotional-isolation-and-relationship-breakdown-on-cinematic-debut-single-silent-eulogy/",
  },
];

export default function Press() {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative bg-ivory py-28 md:py-40 lg:py-48 px-6 md:px-12 lg:px-20"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-16 md:mb-24 max-w-2xl reveal">
          <p className="text-[10px] uppercase tracking-[0.32em] text-teal mb-6">
            Press · Listening Notes
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
            What people are
            <br />
            <em className="italic text-gold">saying.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20">
          {QUOTES.map((q, i) => (
            <figure
              key={i}
              data-testid={`press-quote-${i}`}
              className={`relative reveal ${i % 2 === 1 ? "md:mt-24" : ""}`}
            >
              <span
                aria-hidden="true"
                className="absolute -top-10 -left-2 font-serif text-[120px] leading-none text-ink/10 select-none"
              >
                “
              </span>
              <blockquote className="relative font-serif italic text-2xl md:text-3xl leading-[1.35] text-ink/85 font-light">
                {q.quote}
              </blockquote>
              <div className="ink-divider mt-8" />
              <figcaption className="mt-5 flex flex-wrap items-baseline gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.24em] text-ash">
                <span>— {q.source}</span>
                <a
                  data-testid={`press-quote-link-${i}`}
                  href={q.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-teal hover:text-gold link-underline transition-colors"
                >
                  Read the full review
                </a>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
